import ActiveFilters from './ActiveFilters'

export default ActiveFilters
